import React from "react";
import { usePageData } from "../PageData";
import { SwiperCarousel } from "./SwiperCarousel";

export default function LandingSwiperCarousel() {
  const data = usePageData();

  if (data == null) {
    return null;
  }

  return (
    <>
      {data.carouselBanners?.length > 0 && (
        <SwiperCarousel banners={data.carouselBanners} />
      )}
    </>
  );
}
